export default __webpack_public_path__ + "static/poster-01e8510c310cda98ed8cabb555585662.png";